import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_success",
  "use": "icon-ic_success-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 128 128\" id=\"icon-ic_success\"><g fill=\"none\" fill-rule=\"evenodd\"><circle fill=\"#4A88F7\" fill-rule=\"nonzero\" cx=\"64\" cy=\"64\" r=\"64\" /><path d=\"M56.412 77.401 90.945 42.87a4 4 0 1 1 5.656 5.657L59.213 85.915a4 4 0 0 1-6.027-.426l-17.63-17.63a4 4 0 1 1 5.657-5.657l15.199 15.2z\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol